import React, { useState } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
  FieldInputDollar,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
} from "../../../utils";
import {
  get415ReportInfo,
  getDownload415Report,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import "react-input-range/lib/css/index.css";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "../402ContributionLimit/columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    return <td>$ {value}</td>;
  }
}

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}

const initialValues = {
  //companyName: "Select One",
  companyId: null,
  planName: "All",
};

//const selectOne = { label: "Select One", value: null };
const allOption = { label: "All", value: null };

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Plan ID",
    className: "column-planId",
    columnName: "planId",
    field: "planName",
    width: 111,
    dataType: "alphaNumeric",
    field1: "planName",
  },
  {
    value: 2,
    label: "Pay Date",
    className: "column-payDate",
    columnName: "payDate",
    field: "payDate",
    width: 169,
    dataType: "date",
    field1: "payDateFrom",
    field2: "payDateTo",
  },
  {
    value: 2,
    label: "Employee ID",
    className: "column-employeeNo",
    columnName: "employeeNo",
    field: "employeeNo",
    width: 144,
    dataType: "alphaNumeric",
    field1: "employeeNo",
  },
  {
    value: 3,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 173,
    dataType: "alphaNumeric",
    field1: "ssn",
  },
  {
    value: 4,
    label: "First name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 144,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 5,
    label: "Last name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 149,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 6,
    label: "Date of Birth",
    className: "column-dateOfBirth",
    columnName: "dateOfBirth",
    field: "dateOfBirth",
    width: 169,
    dataType: "date",
    field1: "dateOfBirthFrom",
    field2: "dateOfBirthTo",
  },
  {
    value: 7,
    label: "Pre Tax",
    className: "column-preTax",
    columnName: "preTax",
    field: "preTax",
    width: 133,
    dataType: "amount",
    field1: "preTaxFrom",
    field2: "preTaxTo",
  },
  {
    value: 8,
    label: "Roth",
    className: "column-roth",
    columnName: "roth",
    field: "roth",
    width: 133,
    dataType: "amount",
    field1: "rothFrom",
    field2: "rothTo",
  },
  {
    value: 9,
    label: "After Tax",
    className: "column-afterTax",
    dataType: "amount",
    columnName: "afterTax",
    field: "afterTax",
    width: 133,
    field1: "afterTaxFrom",
    field2: "afterTaxTo",
  },
  {
    value: 10,
    label: "Match",
    className: "column-match",
    columnName: "match",
    dataType: "amount",
    field: "match",
    width: 144,
    field1: "matchFrom",
    field2: "matchTo",
  },
  {
    value: 11,
    label: "Non Elective",
    className: "column-nonElective",
    columnName: "nonElective",
    field: "nonElective",
    dataType: "amount",
    width: 144,
    field1: "nonElectiveFrom",
    field2: "nonElectiveTo",
  },
  {
    value: 12,
    label: "Total contribution",
    className: "column-totalContribution",
    columnName: "totalContribution",
    field: "totalContribution",
    width: 233,
    dataType: "amount",
    field1: "totalContributionFrom",
    field2: "totalContributionTo",
  },
];

const ContributionLimit = (props) => {
  const [final, setFinal] = useState(columns);
  const [gridFilters, setGridFilters] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);

  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
  ]);
  const [totalRecord, setTotalRecord] = useState(0);
  const formName = manageReportsFormNames.CONTRIBUTION_LIMITS;
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [sponsorList, setSponsorList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [trigger, setTrigger] = useState(true);

  const [isScroll, setIsScroll] = useState(false);
  const [sorting, setSorting] = useState();
  const [contribution415Table, setContribution415Table] = useState([]);

  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });
  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });
  const apiCall = (data) => {
    setDataLoading(true);
    get415ReportInfo(data)
      .then((response) => {
        setDataLoading(false);
        setContribution415Table(response.report415Contributions);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
        //handle error
      });

    //setToggle(!toggle);
  };

  useDeepEffect(() => {
    if (!isEmpty(companyList) || !isEmpty(sponsorList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponsorList(values.sponsorOrganizationName);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        nameOrSsn: values.nameOrSsn,
        payDateFrom: values.payDateFrom,
        payDateTo: values.payDateTo,
        amountFrom: values.amountFrom ? parseFloat(values.amountFrom) : 0,
        amountTo: values.amountTo ? parseFloat(values.amountTo) : 0,
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setContribution415Table([]);
      setCompanyList("");
      setSponsorList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          nameOrSsn: filteredValues.nameOrSsn,
          payDateFrom: filteredValues.payDateFrom,
          payDateTo: filteredValues.payDateTo,
          amountFrom: filteredValues.amountFrom
            ? parseFloat(filteredValues.amountFrom)
            : 0,
          amountTo: filteredValues.amountTo
            ? parseFloat(filteredValues.amountTo)
            : 0,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        get415ReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.report415Contributions.length === 0) {
              setIsScroll(false);
            } else {
              setContribution415Table([
                ...contribution415Table,
                ...response.report415Contributions,
              ]);
            }

            // setIsScroll(false);
            //}
          })
          .catch((error) => {
            setDataLoading(false);
          });
      }
    }
  };

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns(final.map((item) => item.value));

    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };

  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    getDownload415Report({ ...filteredValues, selectedColumns: data })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `415ContributionReport_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div> -</div>}</td>;
  };
  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };

  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };

  return (
    <ManageReportLayout rptName="415 Contribution Limits">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
              [fields.nameOrSsn]: "",
              [fields.amountFrom]: "",
              [fields.amountTo]: "",
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];

              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    //values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10 header-button-form"
                  style={{ width: "100% !important" }}
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div
                    className="d-flex align-item-center justify-content-between"
                    style={{ width: "fit-content" }}
                  >
                    <div
                      className="d-flex mr-2"
                      style={{ marginLeft: "2rem", marginTop: "1px" }}
                    >
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "100px" }}>
                              {" "}
                              Select a sponsoring organization or company
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div
                        className="company-name-style"
                        style={{ marginRight: "14px" }}
                      >
                        <Field
                          size="sm"
                          isRequired
                          label={`Company Name ${
                            !values[fields.sponsorOrganizationName] ? "*" : ""
                          }`}
                          name={fields.companyName}
                          disabled={values[fields.sponsorOrganizationName]}
                          value={values[fields.companyName]}
                          placeholder="Select One"
                          direction="bottom"
                          validate={(value) =>
                            ["", undefined, null, "Select One"].includes(
                              value
                            ) && isEmpty(values[fields.sponsorOrganizationName])
                              ? " "
                              : null
                          }
                          popupContent={
                            <SearchableList
                              label="Select Company"
                              options={
                                companies && [
                                  ...companies.map((company, index) => ({
                                    label: company.companyName,
                                    value: index,
                                  })),
                                ]
                              }
                              onSelect={(value) => onCompanyChange(value)}
                              selectedValue={values[fields.companyName]}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3">
                        <Field
                          size="xs"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3">
                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="sm"
                            placeholder="Search SSN, Name"
                            label="Search"
                            isRequired
                            name={fields.nameOrSsn}
                            type="text"
                            autoComplete="off"
                            value={values[fields.nameOrSsn]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                          {values[fields.nameOrSsn] &&
                            values[fields.nameOrSsn].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  height: "100%",
                                  paddingTop: "33px",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="sm"
                                  onClick={() => {
                                    setFieldValue(fields.nameOrSsn, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="d-flex ml-2">
                        <Field
                          size="sm"
                          label="Pay date from "
                          isRequired
                          name={fields.payDateFrom}
                          value={usDateFormat(values[fields.payDateFrom])}
                          direction="bottom"
                          isDatePicker
                          onClear={() =>
                            setFieldValue(fields.payDateFrom, null)
                          }
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateFrom, value)
                              }
                              value={usDateFormat(values[fields.payDateFrom])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3">
                        <Field
                          size="sm"
                          label="Pay date to"
                          isRequired
                          name={fields.payDateTo}
                          value={usDateFormat(values[fields.payDateTo])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.payDateTo, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.payDateTo, value)
                              }
                              value={usDateFormat(values[fields.payDateTo])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value < values[fields.payDateFrom] ? (
                              <div style={{ width: "100px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3">
                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="xs"
                            placeholder="$ 00.00"
                            label="Amount from"
                            isRequired
                            name={fields.amountFrom}
                            type="text"
                            autoComplete="off"
                            value={values[fields.amountFrom]}
                            onChange={handleChange}
                            component={FieldInputDollar}
                          />
                          {values[fields.amountFrom] &&
                            values[fields.amountFrom].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  top: "5px",
                                  height: "100%",
                                  marginTop: "1.9rem",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="sm"
                                  onClick={() => {
                                    setFieldValue(fields.amountFrom, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="d-flex ml-3">
                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="xs"
                            placeholder="$ 00.00"
                            label="Amount to"
                            isRequired
                            name={fields.amountTo}
                            type="text"
                            autoComplete="off"
                            value={values[fields.amountTo]}
                            onChange={handleChange}
                            component={FieldInputDollar}
                          />
                          {values[fields.amountTo] &&
                            values[fields.amountTo].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  top: "5px",
                                  height: "100%",
                                  marginTop: "1.9rem",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="sm"
                                  onClick={() => {
                                    setFieldValue(fields.amountTo, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{ maxWidth: "100%", marginLeft: "83.5%" }}
                    className="d-flex justify-content-between align-center divSpace header-button min-width-200 mr-0 mb-0"
                  >
                    {/* <div className="d-flex flex-col">
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#828282",
                          paddingTop: "6px",
                        }}
                      >
                        {companyList
                          ? `Showing result for ${companyList} company`
                          : null}
                      </div>
                      <div className="ft-12 grey-text font-weight-500">
                        {totalRecord} Records found
                      </div>
                    </div> */}
                    <div className="d-flex">
                      <div
                        style={{
                          diplay: "flex",
                          flexDirection: "column",
                          // marginLeft: "830px",
                          width: "83px",
                        }}
                      >
                        <Button
                          style={{ marginBottom: "12px" }}
                          className="sort-button"
                          variant="secondary"
                          onClick={(e) => {
                            setValues({
                              ...clearFieldValues({
                                values,
                                fieldsToClear: [
                                  fields.planId,
                                  fields.planName,
                                  fields.companyId,
                                  fields.companyName,
                                  fields.sponsorOrganizationName,
                                  fields.sponsorOrganizationId,
                                  fields.amountFrom,
                                  fields.amountTo,
                                  fields.payDateFrom,
                                  fields.payDateTo,
                                ],
                              }),
                            });
                            setFieldValue(fields.nameOrSsn, "");
                            setFieldValue(fields.planName, null);
                            setFieldValue(fields.planId, null);
                            setPlanList([]);
                            setErrors({});
                            setTotalRecord(0);
                            setContribution415Table([]);
                            setCompanyList("");
                          }}
                        >
                          Reset
                        </Button>
                        {/* <div>
                          <Button
                            variant="secondary"
                            className="column-header"
                            onClick={showManageColumns}
                          >
                            <span className="marg-right-6">
                              <i class="fal fa-columns"></i>
                            </span>
                            Column
                          </Button>
                        </div> */}
                        {/* <div
                          className="manage-column-dropdown"
                          style={{ display: "none" }}
                        >
                          <div className="manage-columns ">
                            <p className="manage-columns-button">
                              {" "}
                              Manage columns
                            </p>
                            <p
                              className="apply-button"
                              onClick={() => {
                                hideColumns();
                                setTrigger(!trigger);
                              }}
                            >
                              Close
                            </p>
                          </div>
                          <div>
                            <MultiSelectDropdown
                              hideSelectedOptions="FALSE"
                              width="269px"
                              height="200px"
                              maxHeight="300px"
                              position="absolute"
                              background="white"
                              zIndex="2"
                              options={columns}
                              onSelect={(value) => {
                                setSelectedColumns(value);
                              }}
                              name={"Columns"}
                              value={selectedColumns}
                              trigger={trigger}
                              // disabled={}
                              // isTypeAhead={isEdit}
                            />
                          </div>
                          <div
                            style={{ marginTop: "220px", paddingLeft: "100px" }}
                          >
                            <Button onClick={applyColumns}>Apply</Button>
                          </div>
                        </div> */}
                      </div>

                      <div
                        style={{ width: "91px" }}
                        className="ft-12 grey-text font-weight-500"
                      >
                        <Button
                          className="sort-button"
                          style={{
                            lineHeight: "19px",
                            marginRight: "10%",
                            marginBottom: "12px",
                            marginLeft: "3px",
                            //width: "177.467px"
                          }}
                          variant="secondary"
                          type="submit"
                        >
                          Search
                        </Button>
                        {/* <Button
                          className="export-button"
                          title="Export Excel"
                          variant="secondary"
                          style={{ border: "none" }}
                          // onClick={<ExcelExport />}
                          onClick={() =>
                            !isEmpty(contribution415Table) && exportReportFile()
                          }
                        >
                          <Image src={ExcelImage} width="20px" />
                          Export
                        </Button> */}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
                    <div className="d-flex flex-col">
                      <div style={{ fontSize: "14px", color: "#828282" }}>
                        {companyList
                          ? `Showing result for ${companyList} company`
                          : null}
                      </div>
                      <div
                        className="ft-12 grey-text font-weight-500"
                        // style={{ paddingTop: "6px" }}
                      >
                        {totalRecord} Records found
                      </div>
                    </div>
                    <div className="d-flex">
                      <div style={{ diplay: "flex", flexDirection: "column" }}>
                        <div>
                          <Button
                            variant="secondary"
                            className="column-header col-sty"
                            onClick={hideColumns}
                          >
                            <span className="marg-right-6">
                              <i class="fal fa-columns"></i>
                            </span>
                            Column
                          </Button>
                        </div>
                        <div
                          className="manage-column-dropdown"
                          style={{ display: "none" }}
                        >
                          <div className="manage-columns ">
                            <p className="manage-columns-button">
                              {" "}
                              Manage columns
                            </p>
                            <p
                              className="apply-button"
                              onClick={() => {
                                hideColumns();
                                setTrigger(!trigger);
                              }}
                            >
                              Close
                            </p>
                          </div>
                          <div>
                            <MultiSelectDropdown
                              hideSelectedOptions="FALSE"
                              width="269px"
                              height="200px"
                              maxHeight="300px"
                              position="absolute"
                              background="white"
                              zIndex="2"
                              options={columns}
                              onSelect={(value) => {
                                setSelectedColumns(value);
                              }}
                              name={"Columns"}
                              value={selectedColumns}
                              trigger={trigger}
                            />
                          </div>
                          <div
                            style={{ marginTop: "220px", paddingLeft: "100px" }}
                          >
                            <Button onClick={applyColumns}>Apply</Button>
                          </div>
                        </div>
                      </div>
                      <div className="ft-12 grey-text font-weight-500 marg-right-5">
                        <Button
                          className="export-button"
                          title="Export Excel"
                          variant="secondary"
                          style={{ border: "none" }}
                          onClick={() =>
                            !isEmpty(contribution415Table) && exportReportFile()
                          }
                        >
                          <Image src={ExcelImage} width="20px" />
                          Export
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={contribution415Table}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={contribution415Table}
                  total={contribution415Table.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px", marginBottom: "100px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "date" && dateForm) ||
                        renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(contribution415Table) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default ContributionLimit;
